// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__20Bgt","boxTitle":"Qualiphy_boxTitle__3BRrx","box":"Qualiphy_box__2qGjR","toggleWrap":"Qualiphy_toggleWrap__3Te68"};